// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.User-staticContentPreviewSpace-FPm1l {
  margin: 40px 0;
}`, "",{"version":3,"sources":["webpack://./src/routes/static/user/User.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".staticContentPreviewSpace {\n  margin: 40px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staticContentPreviewSpace": `User-staticContentPreviewSpace-FPm1l`
};
module.exports = ___CSS_LOADER_EXPORT___;
